import { ContentCard } from '../ContentCard/ContentCard';
import { Icon } from '../Icon/Icon';
import { checkmark_2 } from '../Icon/Icon';
import './HeaderCard.css';

interface HeaderCardProps {
	heading: string;
	subheading: string;
	listItems: string[];
	bannerImage: string;
}

export const HeaderCard = ({ heading, subheading, listItems, bannerImage }: HeaderCardProps): JSX.Element => {
	return (
		<div className="header-card content-card">
			<div className="content-text">
				<ContentCard>
					<div>
						<h2 className="main-heading">{heading}</h2>
						<h3 className="sub-heading">{subheading}</h3>
						<div className="check-list">
							<ul>
								{listItems.map((item, index) => (
									<li key={index}>
										<Icon shape={checkmark_2} size={16} />
										{item}
									</li>
								))}
							</ul>
						</div>
					</div>
				</ContentCard>
			</div>
			<div className="banner">
				<img src={bannerImage} alt={heading} />
			</div>
		</div>
	);
};
